import { httpClient } from 'shared/lib'
import axios, { AxiosError } from 'axios'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import { LimitsType } from './types'

export function fetchLimits() {
   let errMessage = ''

   return httpClient
      .get<LimitsType>(`companies/limits`)
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (axios.isAxiosError(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ACCOUNT LIMITS fetchLimits()', errMessage, 'error')
         throw error
      })
}
